/**
 * Formats a number as a US dollar currency string.
 * @param {number} amount The number to format.
 * @return {string} The formatted currency string (e.g., "$1,234.56").
 */
export const formatCurrency = (amount) => {
  return `$${Number(amount || 0).toFixed(2)}`;
};